"use strict";
var BreadcrumbsController = (function () {
    /* @ngInject */
    function BreadcrumbsController($location) {
        this.$location = $location;
    }
    BreadcrumbsController.prototype.followCrumb = function (crumb) {
        if (crumb.onClick) {
            crumb.onClick();
        }
        this.$location.path(crumb.url);
    };
    return BreadcrumbsController;
}());
exports.BreadcrumbsController = BreadcrumbsController;



/** WEBPACK FOOTER **
 ** ./app/common/breadcrumbs/breadcrumbs.controller.ts
 **/